import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Tooltip,
  Input,
  BackTop,
  Tag,
  Modal,
  message,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_afs_scholarshipsform,
  req_edit_afs_scholarshipsform,
  req_downloadfile_afs_scholarshipsform,
} from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  getNowAcademicYear,
  getScholarshipAcademicSemester,
  formateDate,
} from "../../utils/dateUtil";

import StudentApplyDetailModal from "./student-apply-detail-modal";
import RejectCaseModal from "./reject-case-modal";
class ApplyCaseManagement extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",

    nowAcademicYear: getNowAcademicYear(new Date()),
    nowAcademicSemester: getScholarshipAcademicSemester(new Date()),
    isShowModal: false,
    isRejectModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.current = current; // 保存當前頁，給其他方法可看到
    this.api_page_run(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
      token
    );
  };

  api_page_run = async (
    userCode,
    userLevel,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    nowAcademicYear,
    nowAcademicSemester,
    token
  ) => {
    this.setState({ loading: true });
    const result = await req_page_afs_scholarshipsform(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_edit_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_edit_afs_scholarshipsform(item, token);
    if (result.status === "success") {
      this.api_page_items();
    } else {
      message.error(result.message);
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_afs_scholarshipsform(
      userLevel,
      userCode,
      searchField,
      searchValue,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 10,
        responsive: ["md"],
      },
      {
        title: "學期",
        dataIndex: "AcademicSemester",
        width: 10,
        responsive: ["md"],
      },
      {
        title: "申請案號",
        dataIndex: "FormCode",
        width: 25,
        responsive: ["md"],
      },
      {
        title: "學號",
        dataIndex: "ApplicantId",
        width: 18,
      },
      {
        title: "姓名",
        dataIndex: "ApplicantTwName",
        width: 18,
      },
      {
        title: "電話",
        width: 18,
        responsive: ["md"],
        render: (item) => {
          const { Cellphone } = item;
          return (
            <>
              <a
                href={"tel:" + Cellphone}
                target="_blank"
                rel="noreferrer"
                className="btn btn-outline-dark btn-sm btn-block"
              >
                {" "}
                <span>{Cellphone}</span>
              </a>
            </>
          );
        },
      },
      {
        title: "電郵",
        width: 10,
        responsive: ["md"],
        render: (item) => {
          const { EMail } = item;
          return (
            <>
              <a
                href={"mailto:" + EMail}
                target="_blank"
                rel="noreferrer"
                className="btn btn-outline-dark btn-sm btn-block"
              >
                {" "}
                <i className="far fa-envelope"></i>
              </a>
            </>
          );
        },
      },
      {
        title: "科系",
        dataIndex: "DepartmentTwName",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "申請日期",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { RecordCreateDateTime } = item;
          return <span>{formateDate(RecordCreateDateTime)}</span>;
        },
      },
      {
        title: "與校友關係",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const {
            AlumniRelation,
            AlumniCheck,
            AlumniName,
            LastFinalDepartmentName,
          } = item;
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.2em" }}> {AlumniRelation}</span>
              <Tooltip
                placement="bottom"
                title={
                  AlumniCheck === "Y"
                    ? AlumniName + "畢業於本校" + LastFinalDepartmentName
                    : "校友資料庫查無此身份証字號"
                }
              >
                <Tag color={AlumniCheck === "Y" ? "gold" : "default"}>
                  <i className="fa fa-universal-access"></i>
                </Tag>
              </Tooltip>
            </div>
          );
        },
      },
      {
        title: "申請狀態",
        width: 16,
        render: (item) => {
          const { AuditResults } = item;
          return (
            <>
              <div className="text-center">
                <Tag
                  color={this.style_switch_color_tag(
                    "AuditResults",
                    AuditResults
                  )}
                >
                  {this.style_switch_text_tag("AuditResults", AuditResults)}
                </Tag>
              </div>
            </>
          );
        },
      },
      {
        title: "",
        width: 20,
        fixed: "right",
        render: (item) => {
          const { AuditResults } = item;
          return (
            <>
              <button
                type="button"
                className="btn btn-outline-dark btn-sm"
                onClick={() => this.handle_show_ui_modal("view", item)}
              >
                <i className="fa fa-file-word"></i>{" "}
                <span style={{ marginLeft: "4px" }}>輸出</span>
              </button>
              {AuditResults === "APPLY" ? (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-success btn-sm"
                    onClick={() => this.handle_show_ui_modal("pass", item)}
                  >
                    <i className="fa fa-check"></i>{" "}
                    <span style={{ marginLeft: "1px" }}>通過</span>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => this.handle_show_ui_modal("fail", item)}
                  >
                    <i className="fa fa-times"></i>{" "}
                    <span style={{ marginLeft: "4px" }}>拒絕</span>
                  </button>
                </>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {
    //console.log(param);
    if (column === "AuditResults") {
      switch (param) {
        case "APPLY":
          return "red";
        case "PASS":
          return "green";
        case "FAIL":
          return "blue";
        default:
          return "default";
      }
    }
  }

  style_switch_text_tag(column, param) {
    if (column === "AuditResults") {
      switch (param) {
        case "APPLY":
          return "申請中";
        case "PASS":
          return "已通過";
        case "FAIL":
          return "未通過";
        case "CANCEL":
          return "已註銷";
        default:
          return "default";
      }
    }
  }
  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    const { Uid } = item;
    const { userCode } = this.props.user;
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "pass":
        const row_agree = {
          Uid: Uid,
          ReviewerCode: userCode,
          AuditResults: "PASS",
          AuditDescription: "審核通過",
          condition: "BASE",
        };
        this.api_edit_item(row_agree);
        break;

      case "fail":
        this.setState({ isRejectModal: true, item });
        // const row_reject = {
        //   Uid: Uid,
        //   ReviewerCode: userCode,
        //   AuditResults: "REJECT",
        //   AuditDescription: "審核不通過",
        //   condition: "BASE",
        // };
        // this.api_edit_item(row_reject);
        break;
      case "delete":
        const row = {
          Uid: Uid,
          AuditResults: "CANCEL",
          AuditDescription: "申請者自行註銷",
          condition: "CANCEL",
        };
        Modal.confirm({
          title: `您確定註銷此筆數據`,
          onOk: () => {
            this.api_edit_item(row);
          },
        });
        break;
      case "download":
        this.api_downloadfile_items();
        break;
      default:
    }
  };
  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      items,
      item,
      pagination,
      searchValue,
      nowAcademicYear,
      nowAcademicSemester,
      isShowModal,
      isRejectModal,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicYear}
          onChange={(event) =>
            this.setState({ nowAcademicYear: event.target.value })
          }
        />
        <Input
          placeholder="學期"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicSemester}
          onChange={(event) =>
            this.setState({ nowAcademicSemester: event.target.value })
          }
        />
        <select
          style={{
            width: 120,
            height: "31px",
            fontSize: "0.9em",
            color: "#696969",
            backgroundColor: "LightCyan",
            borderColor: "#DCDCDC",
          }}
          onChange={(e) => this.setState({ searchField: e.target.value })}
        >
          <option value="NONE">搜索條件</option>
          <option value="ApplicantId">申請人學號</option>
          <option value="ApplicantTwName">申請人姓名</option>
          <option value="AuditResultsName">申請狀態</option>
        </select>
        <Input
          placeholder="關鍵字"
          style={{
            width: 80,
            margin: "0 5px",
            backgroundColor: "LightYellow",
          }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button type="primary" onClick={() => this.handle_data_download()}>
          <i className="fas fa-cloud-download-alt element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>下載</span>
        </Button>
        <p />
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowModal}
          width={"800px"}
          onOk={() => {
            this.setState({ isShowModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <StudentApplyDetailModal scholarship={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isRejectModal}
          width={"250px"}
          // onOk={() => {
          //   this.setState({ isRejectModal: false });
          //   this.handle_data_refresh();
          // }}
          onCancel={() => {
            this.setState({ isRejectModal: false });
            this.handle_data_refresh();
          }}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
        >
          <RejectCaseModal scholarship={item} />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ApplyCaseManagement);
